import React, {useState} from "react";
import DragNDropFile from "../DragNDropFile";
import axios from "axios";
import {Spinner} from "react-bootstrap";
import { faFileArrowUp} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export default function TimelineSubmitStruct(props) {

    const [status,setStatus] = useState(null);

    function uploadFile(file){
        setStatus("uploading");
        let formData = new FormData()

        formData.append('file', file)

        axios.post("/api/student/upload/struct/"+props.data.caseId+"/"+props.data.studentNumber+'/'+props.data.session,formData,{
            withCredentials: false,
        } )
            .then((response) => {
                setStatus("ok");
                if(response.data.toString().startsWith("true")){
                    //succes
                }else{
                    alert("Uploaden niet gelukt omdat ID niet klopt, meld bij docent aub!");
                }
                props.data.callback();
            })
            .catch((err) => {
                setStatus(null);
                const serverMsg = err?.response?.data;
                if (err?.response?.status === 400 && serverMsg) {
                    alert("Uploaden niet gelukt: " + serverMsg);
                } else {
                    alert("Uploaden niet gelukt: " + (err?.message || "onbekende fout"));
                }
                console.error(`Fetch problem: ${err.message}`);
            });
    }
    if(status === "ok"){
        return (
            <div style={{ color: "#7a7a7a"}} className="text-center"><p>Uploaded</p><FontAwesomeIcon style={{fontSize: "50px"}} icon={faFileArrowUp}/><p><small>Results are being loaded...</small></p></div>
        )
    }else if(status === "uploading"){
        return (
            <div style={{ color: "#7a7a7a"}} className="text-center"><p>Loading grading...</p><Spinner animation="border"/></div>
        )
    }
    return(
        <div>
            <DragNDropFile onUpload={uploadFile}/>
        </div>

    )
}